var _rect, _polygon, _line, _line2, _line3, _line4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoor3DobjectTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.326,
    y: 16.544,
    width: 35.349,
    height: 3.025
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "38.674 16.544 3.326 16.544 13.127 8.631 28.873 8.631 38.674 16.544"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.782,
    y1: 33.369,
    x2: 5.782,
    y2: 19.569
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 36.218,
    y1: 19.569,
    x2: 36.218,
    y2: 33.369
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 13.263,
    y1: 27.081,
    x2: 13.263,
    y2: 19.569
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 28.737,
    y1: 19.569,
    x2: 28.737,
    y2: 27.081
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoor3DobjectTable);
export default __webpack_public_path__ + "static/media/indoor-3dobject_table.0720300af376d849a2b0ddbb97224f01.svg";
export { ForwardRef as ReactComponent };